import React, { FC } from 'react';
import { GetAllCarriers_getAllCarriers as Carrier } from '../../types/schemaTypes';
import { Loading, useLazyLoading } from '../_common';
import { Option } from './interface';
import CarrierItem from './CarrierItem';
import './Carriers.scss';

interface CarrierListProps {
    carriers: Carrier[];
    refetch?: () => void;
    options: Option[];
    canEditCarriers: boolean;
    canAddEditLogisticsPartner: boolean;
    isLoading: boolean;
    isEndOfResults: boolean;
    onEditClick: (Carrier: Carrier) => void;
    onLoadMore: () => void;
    onDelete?: (record: any) => void;
}

const CarrierList: FC<CarrierListProps> = ({
    carriers,
    refetch,
    options,
    isLoading,
    isEndOfResults,
    onEditClick,
    canEditCarriers,
    canAddEditLogisticsPartner,
    onLoadMore,
    onDelete,
}: CarrierListProps): React.ReactElement => {
    // const { handleScroll } = useLazyLoading('carrierList', isLoading, isEndOfResults, onLoadMore);

    // if (refetch) {
    //     refetch();
    // }

    if (isLoading) {
        return (
            <div className="LoadList-Loading">
                <Loading />
            </div>
        );
    }

    return (
        <>
            {carriers.map((carrier, index) => (
                <CarrierItem
                    key={index}
                    index={index}
                    canEditCarriers={canEditCarriers}
                    canAddEditLogisticsPartner ={canAddEditLogisticsPartner}
                    onEditClick={onEditClick}
                    carrier={carrier}
                    options={options}
                    onDelete={onDelete}
                ></CarrierItem>
            ))}
        </>
    );
};

export default CarrierList;

